import { useFragment } from '@apollo/client';
import type {
  IWorkspaceUser,
  WorkspaceParticipant,
} from 'src/@types/workspace-info';
import { useWorkspaceParticipantsAsUsers } from 'src/hooks/useWorkspace';
import { boardParticipantsFragment } from './fragments';

export const useBoardUsers = (boardId: string): IWorkspaceUser[] => {
  const { data } = useFragment({
    fragment: boardParticipantsFragment,
    from: { id: boardId, __typename: 'Board' },
  });
  return useWorkspaceParticipantsAsUsers(
    (data.participants as WorkspaceParticipant[]) || [],
    true,
  );
};
